module.exports = __webpack_public_path__ + "static/img/nibss-logo.3344618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/nibss-logo.png
// module id = ZlrM
// module chunks = 1